<script>
    import TagsForm from './tags-form.svelte';
    import TagsDeleteForm from './tags-delete-form.svelte';
    import { createEventDispatcher } from 'svelte';
    import { format } from 'svelte-i18n';

    const dispatch = createEventDispatcher();
	
    let {
        tags = [],
        allTags = [],
        showTagsForm = false,
        showTagsDeleteForm = false
    } = $props();

</script>
<style>
    .tagList {
        list-style: none;
        color: #535050;
        padding-left: 0 !important;
        display: flex;
        gap: 15px;
        flex-wrap: wrap;
    }

    .tagList li {
        flex: 1;
        min-width: fit-content;
        flex-grow: 0;
    }

    li a span.badge {
        padding-bottom: 0.35em;
        background-color: #E4E4E4 !important;
        font-size: 0.875rem;
    }
</style>
<div class="card-body">
    {#if !showTagsForm && !showTagsDeleteForm}
        <div class="d-flex flex-container-2item">
            {#if tags.length}
                <ul class="tagList">
                    {#each tags as tag (tag.id)}
                        <li class=""><a class="" href="{`/tag/${tag.id}`}"><span class="badge" style="background-color: rgb(33, 37, 41) !important; color: #E4E4E4 !important;">{tag.name}</span></a></li>
                    {/each}
                </ul>
            {:else}
                <div>{$format("no_tags")}</div>
            {/if}
        </div>
    {:else if showTagsForm}
        <TagsForm assetTags={tags} {allTags} on:cancel={()=>dispatch("cancel")} on:submit={(e)=>dispatch("submitTags", e.detail)} />
    {:else if showTagsDeleteForm}
        <TagsDeleteForm assetTags={tags} {allTags} on:cancel={()=>dispatch("cancel")} on:submit={(e)=>dispatch("deleteTags", e.detail)} />
    {/if}
</div>